import React from 'react'
import classes from "./style.module.scss";
import { Images } from '../../../../assets';

const ProfileDetails = ({name, email, letter}) => {
    return (
        <div className={`${classes.profileDetails}`}>
            <div>
                <div className={`${classes.profileLogo} flex items-center justify-center m-auto`}>
                    <div className={`${classes.personLetter}`}>
                        {letter}
                    </div>
                </div>
                <div className={`${classes.profileName} text-center`}>{name}</div>
            </div>
            <div className={`${classes.profileForm} my-4`}>
                <div className={`${classes.profilelable}`}>Email</div>
                <div className={`${classes.profileValue}`}>{email}</div>
            </div>
            <div className={`${classes.profileForm}`}>
                <div className={`${classes.profilelable}`}>Department</div>
                <div className={`${classes.profileValue}`}>Admin</div>
            </div>
        </div>
    )
}

export default ProfileDetails